import { render, staticRenderFns } from "./SignupRecommend.vue?vue&type=template&id=07b21e86&scoped=true&"
import script from "./SignupRecommend.vue?vue&type=script&lang=js&"
export * from "./SignupRecommend.vue?vue&type=script&lang=js&"
import style0 from "./SignupRecommend.vue?vue&type=style&index=0&id=07b21e86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b21e86",
  null
  
)

export default component.exports